var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-tile-control"
  }, [_c('ugc-crop-box', {
    ref: "cropbox",
    attrs: {
      "fabric-canvas": this.fabricCanvas,
      "temp-crop-data": this.tempCropData,
      "lock-square": this.lockSquare,
      "image-format": this.imageFormat
    }
  }), _c('p', {
    staticClass: "ugc-tile-control-text"
  }, [_vm._v("\n    " + _vm._s(_vm.$store.state.utils.configuration.enableNewUgcModal ? _vm.translations.ugcTileControlDesc2 : _vm.translations.ugcTileControlDesc) + "\n  ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }